
import { http } from "../http/Http";
import { LogitudeTokens } from "../models/LogitudeTokens";

export class LogitudeTokensService {

    getTokens = async (): Promise<LogitudeTokens> => {
        const { data } = await http.get<LogitudeTokens>("LogitudeTokens/GetTokens");
        return data;
    };

}